import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Valikud tegemata

  <span style="color:#85c1dc;">**FI:**</span>
  Valinta tekemättä

  <span style="color:#85c1dc;">**RU:**</span>
  Выбор не сделан
*/
/* @__NO_SIDE_EFFECTS__ */
const m259 = msg(
  mf`Valikud tegemata`,
  mf`Valinta tekemättä`,
  mf`Выбор не сделан`,
)

export { m259 as 'w.module.submission_form.choose_options' }